// A downloadable receipt (FR-21) is exactly what /public/receipts/verify takes:
// the signed canonical payload, the signing key id and the signature.
import type { Schemas } from "../../api/client";

export type ReceiptFile = { payload: string; kid: string; signature: string };

export function receiptFile(r: Schemas["Receipt"]): ReceiptFile {
  return { payload: r.payload, kid: r.kid, signature: r.signature };
}

/** parseReceiptFile reads pasted or uploaded JSON; null when it is not a receipt file. */
export function parseReceiptFile(text: string): ReceiptFile | null {
  let v: unknown;
  try {
    v = JSON.parse(text);
  } catch {
    return null;
  }
  if (!v || typeof v !== "object") return null;
  const o = v as Record<string, unknown>;
  const { payload, kid, signature } = o;
  if (typeof payload !== "string" || typeof kid !== "string" || typeof signature !== "string") return null;
  if (!payload || !kid || !signature) return null;
  return { payload, kid, signature };
}

/** downloadJSON saves value as a JSON file through a temporary object URL. */
export function downloadJSON(name: string, value: unknown) {
  const blob = new Blob([JSON.stringify(value, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
